<template>
  <div>
    <h3 class="text-subtitle-1 font-weight-bold mb-3 d-flex align-center ga-2">
      <v-icon
        size="18"
        color="primary"
      >
        mdi-account-tie
      </v-icon>
      {{ $t('onboarding.wizard.data-entry.responsible-person') }}
    </h3>

    <v-row class="mb-4">
      <v-col
        cols="12"
        md="6"
      >
        <OnboardingFormField
          field-key="contactFirstName"
          :label="$t('onboarding.wizard.data-entry.contact-first-name')"
        >
          <v-text-field
            :model-value="formData.contactFirstName"
            id="onboarding-field-contactFirstName"
            data-ai-field="contactFirstName"
            :class="fieldClass('contactFirstName')"
            variant="outlined"
            density="comfortable"
            rounded="lg"
            :placeholder="$t('onboarding.wizard.data-entry.first-name-placeholder')"
            hide-details
            @focus="onFieldFocus('contactFirstName')"
            @update:model-value="updateField('contactFirstName', $event)"
          />
        </OnboardingFormField>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <OnboardingFormField
          field-key="contactLastName"
          :label="$t('onboarding.wizard.data-entry.contact-last-name')"
        >
          <v-text-field
            :model-value="formData.contactLastName"
            id="onboarding-field-contactLastName"
            data-ai-field="contactLastName"
            :class="fieldClass('contactLastName')"
            variant="outlined"
            density="comfortable"
            rounded="lg"
            :placeholder="$t('onboarding.wizard.data-entry.last-name-placeholder')"
            hide-details
            @focus="onFieldFocus('contactLastName')"
            @update:model-value="updateField('contactLastName', $event)"
          />
        </OnboardingFormField>
      </v-col>
    </v-row>

    <OnboardingFormField
      class="mb-4"
      field-key="contactPhone"
      icon="mdi-phone"
      :label="$t('onboarding.wizard.data-entry.phone')"
    >
      <div
        data-ai-field="contactPhone"
        :class="fieldClass('contactPhone')"
        @focusin="onFieldFocus('contactPhone')"
      >
        <PhoneField
          :model-value="formData.contactPhone"
          id="onboarding-field-contactPhone"
          :label="$t('onboarding.wizard.data-entry.phone')"
          update-on-input
          validate-phone
          :country-column-size="{ cols: 5, md: 4, xl: 4 }"
          :phone-column-size="{ cols: 7, md: 8, xl: 8 }"
          @update:model-value="updateField('contactPhone', $event || '')"
        />
      </div>
    </OnboardingFormField>

    <OnboardingFormField
      class="mb-6"
      field-key="contactEmail"
      :label="$t('onboarding.submit.fields.email')"
    >
      <v-text-field
        :model-value="formData.contactEmail"
        id="onboarding-field-contactEmail"
        data-ai-field="contactEmail"
        :class="fieldClass('contactEmail')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        type="email"
        autocomplete="email"
        :rules="[emailRule]"
        :placeholder="$t('onboarding.wizard.data-entry.email-placeholder')"
        hide-details="auto"
        @focus="onFieldFocus('contactEmail')"
        @update:model-value="updateField('contactEmail', $event)"
      />
    </OnboardingFormField>
  </div>
</template>

<script setup lang="ts">
import PhoneField from '@/components/PhoneField.vue'
import { email as emailRule } from '@/lib/validation'

import { useOnboardingDataEntryContext } from '../../composables/onboardingDataEntryContext'
import OnboardingFormField from './OnboardingFormField.vue'

const { formData, updateField, fieldClass, onFieldFocus } = useOnboardingDataEntryContext()
</script>
